import { FronteggContext } from '@frontegg/rest-api';
import { io } from 'socket.io-client';

let summaryStreamSocket;

let url = import.meta.env.VITE_AMBIENT_API_BASE_URL + '/summary';

export function startStreamSummary(
  encounterId,
  encounterPhase,
  onSummary,
  onToken
) {
  summaryStreamSocket = io(url, {
    path: '/socket.io/',
    withCredentials: true,
    query: {
      encounter_id: encounterId,
      encounter_phase: encounterPhase,
    },
    extraHeaders: {
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    },
    reconnection: true,
    reconnectionAttempts: 3,
  });

  summaryStreamSocket.on('summary', (data) => {
    onSummary(data);
  });

  summaryStreamSocket.on('token', (data) => {
    onToken(data);
  });

  summaryStreamSocket.on('connect_error', (error) => {
    console.error('Failed to connect to server:', error);
  });

  summaryStreamSocket.io.on('reconnect_failed', () => {
    console.error('Given up on reconnecting to server.');
  });
}

export function endSummaryStream() {
  if (summaryStreamSocket) {
    summaryStreamSocket.close();
  }
}
